import CompleteInvoicesAlt from './CompleteInvoicesAlt.yaml?component';
import InvoiceGeneration from './InvoiceGeneration.yaml?component';
import UcInvoiceGenerationControlling from './UcInvoiceGenerationControlling.yaml?component';
import UcInvoiceGenerationInvoiceLines from './UcInvoiceGenerationInvoiceLines.yaml?component';
import UcInvoiceGeneratorControls from './UcInvoiceGeneratorControls.yaml?component';
import UcInvoiceGenerationInvoices from './UcInvoiceGenerationInvoices.yaml?component';

export {
  CompleteInvoicesAlt,
  InvoiceGeneration,
  UcInvoiceGenerationControlling,
  UcInvoiceGenerationInvoiceLines,
  UcInvoiceGeneratorControls,
  UcInvoiceGenerationInvoices
};
